var _classCallCheck = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");
var _createClass = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");
var _possibleConstructorReturn = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");
var _get = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/get");
var _inherits = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");
var _assertThisInitialized = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/assertThisInitialized");
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
/**
 * @author mrdoob / http://mrdoob.com/
 */

var THREE = require('../three.js');
(function () {
  var CSS2DObject = /*#__PURE__*/function (_THREE$Object3D) {
    "use strict";

    _inherits(CSS2DObject, _THREE$Object3D);
    function CSS2DObject(element) {
      var _this2;
      _classCallCheck(this, CSS2DObject);
      _this2 = _possibleConstructorReturn(this, _getPrototypeOf(CSS2DObject).call(this));
      _this2.element = element || document.createElement('div');
      _this2.element.style.position = 'absolute';
      _this2.element.style.userSelect = 'none';
      _this2.element.setAttribute('draggable', false);

      //[jscastro] some labels must be always visible
      _this2.alwaysVisible = false;

      //[jscastro] layer is needed to be rendered/hidden based on layer visibility
      Object.defineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), 'layer', {
        get: function get() {
          return this.parent && this.parent.parent ? this.parent.parent.layer : null;
        }
      });

      //[jscastro] implement dispose
      _this2.dispose = function () {
        this.remove();
        this.element = null;
      };
      //[jscastro] implement explicit method
      _this2.remove = function () {
        if (this.element instanceof Element && this.element.parentNode !== null) {
          this.element.parentNode.removeChild(this.element);
        }
      };
      _this2.addEventListener('removed', function () {
        this.remove();
      });
      return _this2;
    }
    _createClass(CSS2DObject, [{
      key: "copy",
      value: function copy(source, recursive) {
        _superPropGet(CSS2DObject, "copy", this, 3)([source, recursive]);
        this.element = source.element.cloneNode(true);
        return this;
      }
    }]);
    return CSS2DObject;
  }(THREE.Object3D);
  CSS2DObject.prototype.isCSS2DObject = true; //

  var _vector = new THREE.Vector3();
  var _viewMatrix = new THREE.Matrix4();
  var _viewProjectionMatrix = new THREE.Matrix4();
  var _a = new THREE.Vector3();
  var _b = new THREE.Vector3();
  var CSS2DRenderer = function CSS2DRenderer() {
    "use strict";

    _classCallCheck(this, CSS2DRenderer);
    var _this = this;
    var _width, _height;
    var _widthHalf, _heightHalf;
    var cache = {
      objects: new WeakMap(),
      list: new Map()
    };
    this.cacheList = cache.list;
    var domElement = document.createElement('div');
    domElement.style.overflow = 'hidden';
    this.domElement = domElement;
    this.getSize = function () {
      return {
        width: _width,
        height: _height
      };
    };
    this.render = function (scene, camera) {
      if (scene.autoUpdate === true) scene.updateMatrixWorld();
      if (camera.parent === null) camera.updateMatrixWorld();
      _viewMatrix.copy(camera.matrixWorldInverse);
      _viewProjectionMatrix.multiplyMatrices(camera.projectionMatrix, _viewMatrix);
      renderObject(scene, scene, camera);
      zOrder(scene);
    };
    this.setSize = function (width, height) {
      _width = width;
      _height = height;
      _widthHalf = _width / 2;
      _heightHalf = _height / 2;
      domElement.style.width = width + 'px';
      domElement.style.height = height + 'px';
    };
    function renderObject(object, scene, camera) {
      if (object.isCSS2DObject) {
        //[jscastro] optimize performance and don't update and remove the labels that are not visible
        if (!object.visible) {
          cache.objects.delete({
            key: object.uuid
          });
          cache.list.delete(object.uuid);
          object.remove();
        } else {
          object.onBeforeRender(_this, scene, camera);
          _vector.setFromMatrixPosition(object.matrixWorld);
          _vector.applyMatrix4(_viewProjectionMatrix);
          var element = object.element;
          var style;
          if (/apple/i.test(navigator.vendor)) {
            // https://github.com/mrdoob/three.js/issues/21415
            style = 'translate(-50%,-50%) translate(' + Math.round(_vector.x * _widthHalf + _widthHalf) + 'px,' + Math.round(-_vector.y * _heightHalf + _heightHalf) + 'px)';
          } else {
            style = 'translate(-50%,-50%) translate(' + (_vector.x * _widthHalf + _widthHalf) + 'px,' + (-_vector.y * _heightHalf + _heightHalf) + 'px)';
          }
          element.style.WebkitTransform = style;
          element.style.MozTransform = style;
          element.style.oTransform = style;
          element.style.transform = style;
          element.style.display = object.visible && _vector.z >= -1 && _vector.z <= 1 ? '' : 'none';
          var objectData = {
            distanceToCameraSquared: getDistanceToSquared(camera, object)
          };
          cache.objects.set({
            key: object.uuid
          }, objectData);
          cache.list.set(object.uuid, object);
          if (element.parentNode !== domElement) {
            domElement.appendChild(element);
          }
          object.onAfterRender(_this, scene, camera);
        }
      }
      for (var i = 0, l = object.children.length; i < l; i++) {
        renderObject(object.children[i], scene, camera);
      }
    }
    function getDistanceToSquared(object1, object2) {
      _a.setFromMatrixPosition(object1.matrixWorld);
      _b.setFromMatrixPosition(object2.matrixWorld);
      return _a.distanceToSquared(_b);
    }
    function filterAndFlatten(scene) {
      var result = [];
      scene.traverse(function (object) {
        if (object.isCSS2DObject) result.push(object);
      });
      return result;
    }
    function zOrder(scene) {
      var sorted = filterAndFlatten(scene).sort(function (a, b) {
        //[jscastro] check the objects already exist in the cache
        var cacheA = cache.objects.get({
          key: a.uuid
        });
        var cacheB = cache.objects.get({
          key: b.uuid
        });
        if (cacheA && cacheB) {
          var distanceA = cacheA.distanceToCameraSquared;
          var distanceB = cacheB.distanceToCameraSquared;
          return distanceA - distanceB;
        }
      });
      var zMax = sorted.length;
      for (var i = 0, l = sorted.length; i < l; i++) {
        sorted[i].element.style.zIndex = zMax - i;
      }
    }
  };
  THREE.CSS2DObject = CSS2DObject;
  THREE.CSS2DRenderer = CSS2DRenderer;
})();
module.exports = exports = {
  CSS2DRenderer: THREE.CSS2DRenderer,
  CSS2DObject: THREE.CSS2DObject
};